import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Paper,
  Grid,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
  Table,
  TableBody
} from '@mui/material';
import { RoleContext } from 'src/context/roleContext';
import GenderPieChart from './GenderPieChart';
import { useTranslation } from 'react-i18next';
import { ActiveModesContext } from 'src/context/ActiveModesContext';
import {
  FLAG_FINALE,
  FLAG_REZULTATI,
  FLAG_REZULTATI_SKOLA_G,
  FLAG_ZALBE
} from 'src/constants/competitions';
import { API_BASE_URL } from 'src/apiConfig';

/* STRANA -Statistika u odnosu na pol*/
const StatisticsByGender = () => {
  const [averageResultData, setAverageResultData] = useState([]);
  const [studentCountData, setStudentCountData] = useState([]);
  const { schoolId } = useContext(RoleContext);
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState(false);

  const { activeModes } = useContext(ActiveModesContext);

  useEffect(() => {
    setViewMode(
      activeModes.includes(FLAG_REZULTATI) ||
        activeModes.includes(FLAG_ZALBE) ||
        activeModes.includes(FLAG_FINALE)
    );
    console.log(activeModes);
    console.log(
      activeModes.includes(FLAG_REZULTATI) ||
        activeModes.includes(FLAG_ZALBE) ||
        activeModes.includes(FLAG_FINALE) ||
        activeModes.includes(FLAG_REZULTATI_SKOLA_G)
    );
  }, [activeModes]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [averageResultResponse, studentCountResponse] = await Promise.all(
          [
            axios.get(`${API_BASE_URL}/api/statistics.php`, {
              params: {
                statistics: 'average_result_by_gender',
                schoolid1: schoolId ? schoolId[0] : null
              }
            }),
            axios.get(`${API_BASE_URL}/api/statistics.php`, {
              params: {
                statistics: 'student_count_by_gender',
                schoolid1: schoolId ? schoolId[0] : null
              }
            })
          ]
        );

        setAverageResultData(averageResultResponse.data);
        setStudentCountData(studentCountResponse.data);
      } catch (error) {
        console.error('Error fetching statistics data:', error);
      }
    };

    fetchData();
  }, [schoolId]);

  return (
    <Box sx={{ padding: '20px', backgroundColor: '#f0f4f8' }}>
      <Typography
        variant="h4"
        sx={{ mb: '30px', textAlign: 'center', color: '#333' }}
      >
        {t('statistic.title')}
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {viewMode && (
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={10}
              sx={{
                p: '30px',
                backgroundColor: 'white',
                borderRadius: '20px',
                boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-10px)'
                }
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: '30px',
                  fontWeight: '700',
                  textAlign: 'center',
                  color: '#333',
                  textTransform: 'uppercase',
                  letterSpacing: '2px'
                }}
              >
                {t('statistic.averageResultTitle')}
              </Typography>
              <GenderPieChart
                data={averageResultData}
                valueKey="Prosecan Rezultat"
                colors={['#A6CEE3', '#86A6B7']}
              />
              <Box sx={{ mt: '20px', textAlign: 'center' }}>
                <Typography variant="h6" sx={{ mb: '10px', fontWeight: '600' }}>
                  {t('statistic.legend')}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', mr: '20px' }}
                  >
                    <Box
                      sx={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'rgb(166, 206, 227)',
                        mr: '10px'
                      }}
                    />
                    <Typography>{t('statistic.male')}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box
                      sx={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'rgb(134, 166, 183)',
                        mr: '10px'
                      }}
                    />
                    <Typography>{t('statistic.female')}</Typography>
                  </Box>
                </Box>
              </Box>

              <StatisticsTable
                data={averageResultData}
                valueKey="Prosecan Rezultat"
                t={t}
              />
            </Paper>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <Paper
            elevation={10}
            sx={{
              p: '30px',
              backgroundColor: 'white',
              borderRadius: '20px',
              boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'translateY(-10px)'
              }
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mb: '30px',
                fontWeight: '700',
                textAlign: 'center',
                color: '#333',
                textTransform: 'uppercase',
                letterSpacing: '2px'
              }}
            >
              {t('statistic.title')}
            </Typography>
            <GenderPieChart
              data={studentCountData}
              valueKey="count"
              colors={['#A6CEE3', '#86A6B7']}
            />
            <Box sx={{ mt: '20px', textAlign: 'center' }}>
              <Typography variant="h6" sx={{ mb: '10px', fontWeight: '600' }}>
                {t('statistic.legend')}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mr: '20px' }}>
                  <Box
                    sx={{
                      width: '20px',
                      height: '20px',
                      backgroundColor: 'rgb(166, 206, 227)',
                      mr: '10px'
                    }}
                  />
                  <Typography>{t('statistic.male')}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: '20px',
                      height: '20px',
                      backgroundColor: 'rgb(134, 166, 183)',
                      mr: '10px'
                    }}
                  />
                  <Typography>{t('statistic.female')}</Typography>
                </Box>
              </Box>
            </Box>

            <StatisticsTable data={studentCountData} valueKey="count" t={t} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

const StatisticsTable = ({ data, valueKey, t }) => {
  if (!data || data.length === 0) {
    return (
      <Typography variant="body1" sx={{ textAlign: 'center', mt: '20px' }}>
        {t('statistic.noData')}
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ mt: '20px', borderRadius: '12px' }}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#e0e0e0' }}>
            <TableCell sx={{ fontWeight: 'bold', color: '#333' }}>
              {t('statistic.gender')}
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: '#333' }}>
              {t('statistic.value')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                {item.Pol === 'm' ? t('statistic.male') : t('statistic.female')}
              </TableCell>
              <TableCell>{item[valueKey]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StatisticsByGender;
